<template>
  <div class="home" id="home">
    <vue-headful title="Fahrzeuge - FF Pfaffenhofen"/>
    <Header :menu-at="0" headerTitle="Fahrzeuge"/>
    <div class="container header-container">
      <h1>Unser Fuhrpark im Überblick</h1>
      <p>
        Die Kinder interessieren sich für die roten Autos mit den blauen Lichtern 
        und die Erwachsenen staunen über die Technik, die sich hinter ihnen verbirgt. 
        Die Rede ist von Feuerwehrfahrzeugen. Für uns sind sie Transportmittel für 
        Material und Einsatzkräfte.
      </p>

      <h2>Fahrzeugtouren und weitere Informationen</h2>
      <p>
        Wählen Sie die einzelnen Fahrzeuge aus um mehr 
        Details zu Fahrzeug und der jeweiligen Beladung zu erhalten und einen digitalen Fahrzeugrundgang zu starten.
      </p>

      <div class="flex-container">
        <div class="card card-lf" @mouseenter="toggleLF()" @mouseleave="toggleLF()">
          <div class="start-icon"> 
            <font-awesome-icon @click="changeRoute('lf')" icon="play-circle" />
          </div>
          <div class="card-suptitle" v-show="hoverLF">LF 16/12</div>
          <div class="card-title" v-show="hoverLF">Löschgruppenfahrzeug</div>
        </div>
        <div class="card card-tlf" @mouseenter="toggleTLF()" @mouseleave="toggleTLF()">
          <div class="start-icon">
            <font-awesome-icon @click="changeRoute('hlf')" icon="play-circle" />
          </div>
          <div class="card-suptitle" v-show="hoverTLF">HLF20</div>
          <div class="card-title" v-show="hoverTLF">Hilfeleistungslöschfahrzeug</div>
        </div>
        <div class="card card-mzf" @mouseenter="toggleMZF()" @mouseleave="toggleMZF()">
          <div class="start-icon">
            <font-awesome-icon @click="changeRoute('mzf')" icon="play-circle" />
          </div>
          <div class="card-suptitle" v-show="hoverMZF">MZF</div>
          <div class="card-title" v-show="hoverMZF">Mehrzweckfahrzeug</div>
        </div>
      </div>
      
      <!--  
      <div class="description-container" v-show="!smallScreen">
        <p v-show="hoverLF">LF Description Test, Lorem ipsum dolor sit amet consectetur, adipisicing elit. Minima, excepturi!	 </p>
        <p v-show="hoverTLF">TLF Description Test, Lorem ipsum dolor sit amet consectetur, adipisicing elit. Minima, excepturi!	 </p>
        <p v-show="hoverMZF">MZF Description Test, Lorem ipsum dolor sit amet consectetur, adipisicing elit. Minima, excepturi!	 </p>
      </div> --> <br>

      <h2>Fahrzeuge im Einsatz</h2>
      <p>
          Die Feuerwehr Pfaffenhofen kann im Einsatzfall auf 3 modere und auf die verschiedenen Aufgaben 
          bestens ausgerüsteten Einsatzfahrzeuge zurückgreifen. <br> <br>
          Seit 07/2020 darf sich die FF Pfaffenhofen über ein nagelneues <b>Hilfeleistungslöschfahrzeug 
          HLF20</b> mit dem Funkrufnamen “Florian Pfaffenhofen 40/2” freuen. Es ist das 
          Grundversorgungsfahrzeug für den gesamten Marktbereich und darüber hinaus. Es ist
          das Mittel der Wahl und somit bei jedem Ersteinsatz dabei. <br>
          Zum andern gibt es noch das <b>Löschgruppenfahrzeug LF 16/12</b> mit dem Funkrufnamen 
          "Florian Pfaffenhofen 40/1" Es rückt nach dem HLF20 als Zweitfahrzeug und zu Türöffnungen 
          als Ersteinsatzfahrzeug aus und bringt mit seinem großen 1600 Liter fassenden Wassertank und 
          einer fest eingebauten Schaumzumischanlage eine gute Wasserreserve / weiteres Löschmittel mit. <br><br>
          Für den Transport von zusätzlichen Einsatzkräften und zum Ziehen des Hochwasseranhängers 
          oder zusätzlichen Materialien, wie zum Beispiel Ölbindemittel, kommt das <b>Mehrzweckfahrzeug</b> 
          (Funkrufname "Florian Pfaffenhofen 11/1") zum Einsatz. Es dient aber auch dem Einsatzleiter 
          als Vorausfahrzeug, damit dieser die Lage vor dem Eintreffen des HLF20 bereits
           erkunden kann und so wertvolle Zeit sparen kann.
      </p>
      
      <div class="space"></div>
    </div>
    
    <Footer />
    <Scroll2Top />

  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Scroll2Top from '@/components/Scroll2Top.vue'

export default {
  name: 'home',
  components: {
    Header, Footer, Scroll2Top
  },
  data () {
    return {
      hoverLF: false,
      hoverTLF: false,
      hoverMZF: false
    }
  }, methods: {
    toggleLF() {
      this.hoverLF = !this.hoverLF
    },
    toggleTLF() {
      this.hoverTLF = !this.hoverTLF
    },
    toggleMZF() {
      this.hoverMZF = !this.hoverMZF
    },
    changeRoute(location) {
      let newRoute = "tour_" + location 
      this.$router.push(newRoute)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

.header-container {
  padding-top: 100px;


  p {
  color: rgba(0,0,0,.7);
  line-height: 26px;
  }

  b {
    color: rgba(0,0,0,.85)
  }

}

h1 {
  text-align: center;

  @include tablet {
    text-align: left;
  }
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-content: flex-start;
  margin: 30px 0px 10px 0px;
}

.card {
  width: 320px;
  height: 220px;
  margin: 20px 10px;
  background: $light-0;
  box-shadow: $shadow-medium;
  border-radius: 10px;
  transition: all 0.2s;
  cursor: pointer;
  position: relative;
}

.card-background-lf:hover {
  filter: brightness(40%)
}

.card-suptitle {
  color: $primary;
  font-weight: bold;
  position: absolute;
  left: 20px;
  bottom: 40px;
}


.card-title {
  color: $light-0;
  font-weight: bold;
  position: absolute;
  left: 20px;
  bottom: 15px;
}

.start-icon{
  font-size: 75px;
  color: $light-0;
  width: 100%;

  position: absolute;
  top: 45px;
  text-align: center;
  transition: all 0.5s;
  opacity: 0.3;
}


.start-icon:hover, a {
  color: mix($light-0, $primary, 0.4);
  transition: all 0.5s;
  opacity: 1;
}

.card-lf {
  background: url(/vehicles/lf1612_d.gif);
  background-size: cover;
  filter: brightness(200%);
}

.card-lf:hover {
  filter: brightness(100%);
}

.card-tlf {
  background: url(/vehicles/hlf_d.gif);
  background-size: cover;
  filter: brightness(200%);
}

.card-tlf:hover {
  filter: brightness(100%);
}

.card-mzf {
  background: url(/vehicles/mzf_d.gif);
  background-size: cover;
  filter: brightness(200%);
}

.card-mzf:hover {
  filter: brightness(100%);
}

.card:hover {
  transition: all 0.2s;
}

.space {
  margin-top: 50px;
}

.description-container {
  height: 100px;
  position: relative;

  p {
    position:absolute;
  }
}


</style>
